import { resolveKbItemStatus } from './sections/KbItemProgressionSection';
import type { TrainingInsights } from './types';

/**
 * The bold line under "Training Quality Score" for an abandoned session:
 * how far the session got before it ended. Empty for a finished session.
 *
 * A knowledge base read-out counts its items (every track item is in
 * kbItemProgression, unreached ones as not_attempted); a Playbook Live
 * session has no fixed item list, so it says only that it ended early.
 */
export const describeEndedEarly = (insights: TrainingInsights): string => {
  if (!insights?.wasAbandoned) return '';
  const progression = insights?.salesIntelligence?.kbItemProgression || [];
  if (progression.length === 0) return 'Session ended early, before the conversation finished.';
  const missed = progression.filter((item) => resolveKbItemStatus(item) === 'not_attempted').length;
  const reached = progression.length - missed;
  return `Session ended early: ${reached} of ${progression.length} knowledge base items reached, `
    + `${missed} not attempted.`;
};
